import { createSlice } from '@reduxjs/toolkit';

import { Invoice } from '@mfe/shared/schema-types';

export enum Route {
  Home = 'Home',
  Payments = 'Payments',
  OneTimePayment = 'OneTimePayment',
  Autopay = 'Autopay',
}

type Props = {
  invoice?: Invoice | null;
};

type BillingNavState = {
  route: Route;
  props: Props;
};

const initialState: BillingNavState = {
  route: Route.Home,
  props: {},
};

export const billingNavSlice = createSlice({
  name: 'billingNav',
  initialState,
  reducers: {
    setBillingNav: (
      state,
      { payload }: { payload: Partial<BillingNavState> }
    ) => ({
      route: payload?.route ? payload.route : state.route,
      props: payload.props ?? {},
    }),
    resetBillingNav: () => initialState,
  },
});

export const { setBillingNav, resetBillingNav } = billingNavSlice.actions;

export const selectBillingNav = (state: { billingNav: BillingNavState }) =>
  state.billingNav;
